<!--在线监管-报警管理-监测-->
<template>
    <div v-if="isShowNotificationDialog" style="background-color: #fff; padding-left:2%;padding-right:2%;padding-bottom:20px;">
        <point-info-dialog
        :device="device"
        ></point-info-dialog>
    </div>
  </template>
  <script>
  import PointInfoDialog from "@/component/PointInfoDialog.vue";
  import { stg } from '@/util/index'
  export default {
    props: ['localeId'],
    components: {PointInfoDialog},
    data() {
        return {
            isShowNotificationDialog: false,
            device:{}
        }
    },
    
    async created() {
        if (this.$router.currentRoute.query.token) {
           await stg().setItem('token', this.$router.currentRoute.query.token)
        } else {
            this.$message('token不能为空');
            return
        }
        const par = {locale_id: this.localeId}
        this.$get('admin/locale/info', par)
        .then((res) => {
            this.device = res.locale
            this.isShowNotificationDialog = true
        })
        .catch(() => {
        })
    },
    methods: {
     
     
    },
  };
  </script>
  